import React, { ReactElement, isValidElement, cloneElement, Children} from "react";
import classNames from "classnames";
import { ListProps } from "./PropsType";

export default function List(props: ListProps) {
  const {
    avatarRight,
    children: childrenProps,
    className,
    disableRipple = true,
    prefixCls = "bm-List",
    ...other
  } = props;
  const styleClass = classNames(
    prefixCls,
    avatarRight ? `${prefixCls}-avatar-right` : "",
    className
  );
  const children = Children.map(
    childrenProps,
    (child: ReactElement<any>, index: number) => {
      if (!isValidElement(child)) {
        return;
      }
      const props: any = { ...(child.props || {}) };
      props.index = index;
      props.disableRipple = disableRipple!;
      return cloneElement(child, props);
    }
  );
  return (
    <ul className={styleClass} {...other}>
      {children}
    </ul>
  );
}
